function LiveStatsFormatter(num) {
  const symbolK = 'k';
  const symbolM = 'M';
  if (num.length <= 3) {
    return num;
  }
  if (num.length === 4) {
    return Intl.NumberFormat('en-US').format(num);
  }
  if (num.length === 5) {
    return (num / 1000).toString().slice(0, 5) + symbolK;
  }
  if (num.length === 6) {
    return (num / 1000).toString().slice(0, 5) + symbolK;
  }
  if (num.length === 7) {
    return (num / 1000000).toString().slice(0, 5) + symbolM;
  }
  if (num.length === 8) {
    return (num / 1000000).toString().slice(0, 6) + symbolM;
  }
  if (num.length === 9) {
    return (num / 1000000).toString().slice(0, 7) + symbolM;
  }
}

export default LiveStatsFormatter;
